import(/* webpackMode: "eager" */ "/home/ubuntu/download/69632a587683ed0014e536c0/desisocio_portfolio/src/app/not-found.tsx");
